import { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import "../../statusIcon.css";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { loadSiteMonitoring } from "../../redux/siteMonitoring/siteMonitoringActions";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import { formatStatus } from "../../redux/siteMonitoring/siteMonitoringStatusActions";
import "./SiteMonitoringListDetail.css";

class SiteMonitoringListDetail extends Component {
	displaySiteMonitoring() {
		this.props.loadSiteMonitoring(
			this.props.siteMonitoring,
			this.props.activeUser
		);
		this.props.history.push("/siteMonitorings/siteMonitoring");
		this.props.globalContainer.current.scrollTop = 0
	}

	render() {
		let address = this.props.siteMonitoring.delivery_partner_id;
		let city;
		let title = "";
		let nbWaitingAction = this.props.siteMonitoring.nbNotesAssignedToMe;

		city = address ? address.city : "";

		if (
			this.props.siteMonitoring.delivery_partner_id &&
			this.props.siteMonitoring.delivery_partner_id.customer_code
		)
			title =
				this.props.siteMonitoring.delivery_partner_id.name +
				" [" +
				this.props.siteMonitoring.delivery_partner_id.customer_code +
				"]";

		return (
			<div className="col-lg-4 col-md-4 col-sm-6 col-12 div-site-monitoring-card">
				<div ref={(divRef) => (this.divRef = divRef)}>
					<Card className="col-lg-12 col-md-12 col-sm-12 col-12 card site-monitoring-card card-margin-top without-side-padding">
						<CardContent
							className="without-padding card-content-left-align"
							onClick={this.displaySiteMonitoring.bind(this)}
						>
							<div>
								<div className="row">
									<div className="col-lg-12 col-md-12 col-sm-12 col-12 row">
										<div className="without-side-padding blue-text">
											<span className="bold">{title}</span>
											{this.props.siteMonitoring.delivery_partner_id &&
												this.props.siteMonitoring.delivery_partner_id
													.customer_code && <span>{", " + city}</span>}
										</div>
									</div>
								</div>
								<div className="row site-monitoring-card-body-margin">
									<div className="col-lg-12 col-md-12 col-sm-12 col-12 row card-divider-div"></div>
									<div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding row card-div-border-right">
										<div className="span-center bold">
											<div className="row">
												{this.props.siteMonitoring.name}
											</div>
										</div>
									</div>
									<div className="col-lg-12 col-md-12 col-sm-12 col-12 row card-divider-div"></div>
									<div className="col-lg-4 col-md-4 col-sm-4 col-4 without-side-padding row card-div-border-right">
										<div className="span-center bold">
											<div className="row">
												{this.props.siteMonitoring.code}
											</div>
										</div>
									</div>
									<div className="col-lg-8 col-md-8 col-sm-8 col-8 without-side-padding row">
										<div className="span-center">
											<span>
												{this.props.siteMonitoring.date_start.format(
													"DD/MM/YYYY"
												) +
													" - " +
													this.props.siteMonitoring.date.format("DD/MM/YYYY")}
											</span>
										</div>
									</div>
									<div className="col-lg-12 col-md-12 col-sm-12 col-12 row without-side-padding">
										<div className="col-lg-12 col-md-12 col-sm-12 col-12 row card-divider-div"></div>
										<div className="col-lg-4 col-md-4 col-sm-4 col-4 without-side-padding row card-div-border-right">
											<div className="span-center">
												<span>
													{formatStatus(this.props.siteMonitoring.state)}
												</span>
											</div>
										</div>
										<div className="col-lg-8 col-md-8 col-sm-8 col-8 row">
											<div className="col-lg-2 col-md-2 col-sm-2 col-2 without-side-padding ">
												<NotificationsActiveIcon
													fontSize="small"
													className="red-icon"
												/>
											</div>
											<div className="without-side-padding blue-text col-lg-10 col-md-10 col-sm-10 col-10">
												{nbWaitingAction + " action(s) en attente"}
											</div>
										</div>
									</div>
								</div>
							</div>
						</CardContent>
					</Card>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		activeUser: state.activeUser,
		notesFilters: state.notes.notesFilters,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		loadSiteMonitoring: (siteMonitoring, activeUser) =>
			dispatch(loadSiteMonitoring(siteMonitoring, activeUser)),
	};
};

export default compose(
	withRouter,
	connect(mapStateToProps, mapDispatchToProps)
)(SiteMonitoringListDetail);
